import { maskPhone } from '@rad/utility/formatting';
import { getMetaValue } from '@rad/utility/meta';
export const initialAuthContext = getMetaValue('76U-AUTH-CONTEXT');
export const email = (value) => ({ type: 'email', value });
export const phone = (value) => ({ type: 'phone', value });
export const emptyIdentifier = (type) => ({ type, value: '' });
export const isEmail = (i) => i.type === 'email';
export const isPhone = (i) => i.type === 'phone';
export const setValue = (i, raw) => isPhone(i) ? Object.assign(Object.assign({}, i), { value: maskPhone(raw) }) : Object.assign(Object.assign({}, i), { value: raw });
